import Vue from 'vue';
import VueI18n from 'vue-i18n';

Vue.use(VueI18n);

import { useClientChecker } from './client-checker';

// EN
import enSectionGlobal from '../../i18n/en/global.json';
import enSectionSharing from '../../i18n/en/sharing.json';
import enSectionAccess from '../../i18n/en/access.json';
import enSectionPrivacyPolicy from '../../i18n/en/privacyPolicy.json';
// IT
import itSectionGlobal from '../../i18n/it/global.json';
import itSectionSharing from '../../i18n/it/sharing.json';
import itSectionAccess from '../../i18n/it/access.json';
import itSectionPrivacyPolicy from '../../i18n/it/privacyPolicy.json';
// DE
import deSectionGlobal from '../../i18n/de/global.json';
import deSectionSharing from '../../i18n/de/sharing.json';
import deSectionAccess from '../../i18n/de/access.json';
import deSectionPrivacyPolicy from '../../i18n/de/privacyPolicy.json';
// ES
import esSectionGlobal from '../../i18n/es/global.json';
import esSectionSharing from '../../i18n/es/sharing.json';
import esSectionAccess from '../../i18n/es/access.json';
import esSectionPrivacyPolicy from '../../i18n/es/privacyPolicy.json';
// FR
import frSectionGlobal from '../../i18n/fr/global.json';
import frSectionSharing from '../../i18n/fr/sharing.json';
import frSectionAccess from '../../i18n/fr/access.json';
import frSectionPrivacyPolicy from '../../i18n/fr/privacyPolicy.json';
// HU
import huSectionGlobal from '../../i18n/hu/global.json';
import huSectionSharing from '../../i18n/hu/sharing.json';
import huSectionAccess from '../../i18n/hu/access.json';
import huSectionPrivacyPolicy from '../../i18n/hu/privacyPolicy.json';
// PL
import plSectionGlobal from '../../i18n/pl/global.json';
import plSectionSharing from '../../i18n/pl/sharing.json';
import plSectionAccess from '../../i18n/pl/access.json';
import plSectionPrivacyPolicy from '../../i18n/pl/privacyPolicy.json';
// PT
import ptSectionGlobal from '../../i18n/pt/global.json';
import ptSectionSharing from '../../i18n/pt/sharing.json';
import ptSectionAccess from '../../i18n/pt/access.json';
import ptSectionPrivacyPolicy from '../../i18n/pt/privacyPolicy.json';
// RO
import roSectionGlobal from '../../i18n/ro/global.json';
import roSectionSharing from '../../i18n/ro/sharing.json';
import roSectionAccess from '../../i18n/ro/access.json';
import roSectionPrivacyPolicy from '../../i18n/ro/privacyPolicy.json';
// NL
import nlSectionGlobal from '../../i18n/nl/global.json';
import nlSectionSharing from '../../i18n/nl/sharing.json';
import nlSectionAccess from '../../i18n/nl/access.json';
import nlSectionPrivacyPolicy from '../../i18n/nl/privacyPolicy.json';
// RU
import ruSectionGlobal from '../../i18n/ru/global.json';
import ruSectionSharing from '../../i18n/ru/sharing.json';
import ruSectionAccess from '../../i18n/ru/access.json';
import ruSectionPrivacyPolicy from '../../i18n/ru/privacyPolicy.json';
// CS
import csSectionGlobal from '../../i18n/cs/global.json';
import csSectionSharing from '../../i18n/cs/sharing.json';
import csSectionAccess from '../../i18n/cs/access.json';
import csSectionPrivacyPolicy from '../../i18n/cs/privacyPolicy.json';
// SL
import slSectionGlobal from '../../i18n/sl/global.json';
import slSectionSharing from '../../i18n/sl/sharing.json';
import slSectionAccess from '../../i18n/sl/access.json';
import slSectionPrivacyPolicy from '../../i18n/sl/privacyPolicy.json';

import en_US from 'date-fns/locale/en-US';
import de from 'date-fns/locale/de';
import es from 'date-fns/locale/es';
import fr from 'date-fns/locale/fr';
import hu from 'date-fns/locale/hu';
import it from 'date-fns/locale/it';
import nl from 'date-fns/locale/nl';
import pl from 'date-fns/locale/pl';
import pt from 'date-fns/locale/pt';
import ro from 'date-fns/locale/ro';
import ru from 'date-fns/locale/ru';
import cs from 'date-fns/locale/cs';
import sl from 'date-fns/locale/sl';

export function loadTranslations() {
    let translations = {
        en: {},
        it: {},
        de: {},
        es: {},
        fr: {},
        hu: {},
        pl: {},
        pt: {},
        ro: {},
        nl: {},
        ru: {},
        cs: {},
        sl: {},
    };

    loadTranslation(translations.en, enSectionGlobal);
    loadTranslation(translations.en, enSectionSharing);
    loadTranslation(translations.en, enSectionAccess);
    loadTranslation(translations.en, enSectionPrivacyPolicy);

    loadTranslation(translations.it, itSectionGlobal);
    loadTranslation(translations.it, itSectionSharing);
    loadTranslation(translations.it, itSectionAccess);
    loadTranslation(translations.it, itSectionPrivacyPolicy);

    loadTranslation(translations.de, deSectionGlobal);
    loadTranslation(translations.de, deSectionSharing);
    loadTranslation(translations.de, deSectionAccess);
    loadTranslation(translations.de, deSectionPrivacyPolicy);

    loadTranslation(translations.es, esSectionGlobal);
    loadTranslation(translations.es, esSectionSharing);
    loadTranslation(translations.es, esSectionAccess);
    loadTranslation(translations.es, esSectionPrivacyPolicy);

    loadTranslation(translations.fr, frSectionGlobal);
    loadTranslation(translations.fr, frSectionSharing);
    loadTranslation(translations.fr, frSectionAccess);
    loadTranslation(translations.fr, frSectionPrivacyPolicy);

    loadTranslation(translations.hu, huSectionGlobal);
    loadTranslation(translations.hu, huSectionSharing);
    loadTranslation(translations.hu, huSectionAccess);
    loadTranslation(translations.hu, huSectionPrivacyPolicy);

    loadTranslation(translations.pl, plSectionGlobal);
    loadTranslation(translations.pl, plSectionSharing);
    loadTranslation(translations.pl, plSectionAccess);
    loadTranslation(translations.pl, plSectionPrivacyPolicy);

    loadTranslation(translations.pt, ptSectionGlobal);
    loadTranslation(translations.pt, ptSectionSharing);
    loadTranslation(translations.pt, ptSectionAccess);
    loadTranslation(translations.pt, ptSectionPrivacyPolicy);

    loadTranslation(translations.ro, roSectionGlobal);
    loadTranslation(translations.ro, roSectionSharing);
    loadTranslation(translations.ro, roSectionAccess);
    loadTranslation(translations.ro, roSectionPrivacyPolicy);

    loadTranslation(translations.nl, nlSectionGlobal);
    loadTranslation(translations.nl, nlSectionSharing);
    loadTranslation(translations.nl, nlSectionAccess);
    loadTranslation(translations.nl, nlSectionPrivacyPolicy);

    loadTranslation(translations.ru, ruSectionGlobal);
    loadTranslation(translations.ru, ruSectionSharing);
    loadTranslation(translations.ru, ruSectionAccess);
    loadTranslation(translations.ru, ruSectionPrivacyPolicy);

    loadTranslation(translations.cs, csSectionGlobal);
    loadTranslation(translations.cs, csSectionSharing);
    loadTranslation(translations.cs, csSectionAccess);
    loadTranslation(translations.cs, csSectionPrivacyPolicy);

    loadTranslation(translations.sl, slSectionGlobal);
    loadTranslation(translations.sl, slSectionSharing);
    loadTranslation(translations.sl, slSectionAccess);
    loadTranslation(translations.sl, slSectionPrivacyPolicy);

    return translations;
}

function loadTranslation(storage: any, section: any) {
    let prefix = section.section;

    for (let screen of section.screens) {
        for (let key in screen.keys) {
            let name = `${prefix}${key[0].toLocaleUpperCase()}${key.substring(1)}`;
            storage[name] = typeof screen.keys[key] == 'string' ? screen.keys[key] : screen.keys[key] && screen.keys[key].text;
        }
    }
}

export function getDateFnsLocale(locale: string, fallbackLocale: string) {
    function get(l: string) {
        switch (locale.substring(0, 2)) {
            case 'en':
            case 'en-US':
                return en_US;

            case 'de':
                return de;

            case 'es':
                return es;

            case 'fr':
                return fr;

            case 'hu':
                return hu;

            case 'it':
                return it;

            case 'nl':
                return nl;

            case 'pl':
                return pl;

            case 'pt':
                return pt;

            case 'ro':
                return ro;

            case 'ru':
                return ru;

            case 'cs':
                return cs;

            case 'sl':
                return sl;

            default:
                return null;
        }
    }

    return get(locale)
        || get(locale.substring(0, 2))
        || (fallbackLocale && get(fallbackLocale))
        || (fallbackLocale && get(fallbackLocale.substring(0, 2)));
}

export function getPrivacyPolicyLocalizedUrl(locale: string) {
    var client = useClientChecker();

    if (client.clientIsYou.value) {
        return getYouPrivacyPolicyLocalizedUrl(locale);
    }

    return getGenericPrivacyPolicyLocalizedUrl(locale);
}

function getYouPrivacyPolicyLocalizedUrl(locale: string) {
    switch (locale.substring(0, 2)) {
        case 'de':
            return 'https://www.findernet.com/de/deutschland/datenschutzerklarung-von-finder-apps/';

        case 'es':
            return 'https://www.findernet.com/es/espana/politica-de-privacidad-delle-app-finder/';

        case 'fr':
            return 'https://www.findernet.com/fr/france/politique-de-confidentialite-de-lapplication-finder/';

        case 'hu':
            return 'https://www.findernet.com/hu/magyarorszag/finder-apps-privacy-policy/';

        case 'it':
            return 'https://www.findernet.com/it/italia/privacy-policy-finder-you/';

        case 'nl':
            return 'https://www.findernet.com/nl/nederland/finder-apps-privacy-policy/';

        case 'pl':
            return 'https://www.findernet.com/pl/polska/finder-apps-privacy-policy/';

        case 'pt':
            return 'https://www.findernet.com/pt/brasil/politica-de-privacidade-app/';

        case 'ro':
            return 'https://www.findernet.com/ro/romania/finder-apps-privacy-policy/';

        case 'cs':
            return 'https://www.findernet.com/cs/ceska-republika/finder-apps-privacy-policy/';

        case 'sl':
            return 'https://www.findernet.com/sl/slovenija/finder-apps-privacy-policy/';

        case 'ru':
        case 'en':
        default:
            return 'https://www.findernet.com/en/worldwide/privacy-policy-finder-you/';
    }
}

function getGenericPrivacyPolicyLocalizedUrl(locale: string) {
    switch (locale.substring(0, 2)) {
        case 'de':
            return 'https://www.findernet.com/de/deutschland/datenschutzerklarung-von-finder-apps/';

        case 'es':
            return 'https://www.findernet.com/es/espana/politica-de-privacidad-delle-app-finder/';

        case 'fr':
            return 'https://www.findernet.com/fr/france/politique-de-confidentialite-de-lapplication-finder/';

        case 'hu':
            return 'https://www.findernet.com/hu/magyarorszag/finder-apps-privacy-policy/';

        case 'it':
            return 'https://www.findernet.com/it/italia/privacy-policy-app/';

        case 'nl':
            return 'https://www.findernet.com/nl/nederland/finder-apps-privacy-policy/';

        case 'pl':
            return 'https://www.findernet.com/pl/polska/finder-apps-privacy-policy/';

        case 'pt':
            return 'https://www.findernet.com/pt/brasil/politica-de-privacidade-app/';

        case 'ro':
            return 'https://www.findernet.com/ro/romania/finder-apps-privacy-policy/';

        case 'cs':
            return 'https://www.findernet.com/cs/ceska-republika/finder-apps-privacy-policy/';

        case 'sl':
            return 'https://www.findernet.com/sl/slovenija/finder-apps-privacy-policy/';

        case 'ru':
        case 'en':
        default:
            return 'https://www.findernet.com/en/worldwide/finder-apps-privacy-policy/';
    }
}

let i18n: VueI18n;

export function init() {

    if (i18n == null) {
        let qs = window.location.search.split('&').map(x => { let p = x.split('='); return [p[0].replace('?', ''), p[1]]; });
        let language = qs.find(x => x[0] == 'language') && qs.find(x => x[0] == 'language')[1];
        if (!language) {
            let returnUrl = qs.find(x => x[0] == 'returnUrl') && qs.find(x => x[0] == 'returnUrl')[1];
            if (returnUrl) {
                let qsReturnUrl = returnUrl.split('%26').map(x => { let p = x.split('%3D'); return [p[0].replace('%3F', ''), p[1]]; });
                language = qsReturnUrl.find(x => x[0] == 'language') && qsReturnUrl.find(x => x[0] == 'language')[1];
            }
        }

        i18n = new VueI18n({
            locale: language || navigator?.language || 'en',
            fallbackLocale: 'en',
            messages: loadTranslations()
        });
    }

    return i18n;
}

export function useI18n() {
    return i18n;
}
